// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__sqVJr","inner":"Form_inner__d2eXR","range":"Form_range__2U8lZ","name":"Form_name__3UkLG","actions":"Form_actions__3kQ0W"};